<template slot-scope="scope">
  <div>
    <ods-dialog
  title="¿Estás seguro?"
  :visible.sync="isVisible"
  width="30%"
  :before-close="handleClose"
  :append-to-body="true">
  <span class="estas-a-punto-de-eli">Estás a punto de eliminar este terminal de forma permanente</span>
  <span slot="footer" class="dialog-footer">
    <ods-button type="text" @click="handleClose()">cancel</ods-button>
    <ods-button @click="deleteTPV" type="danger">eliminar</ods-button>
  </span>
</ods-dialog>
  <dialog-generic-error
      :message="errorMessage"
      :dialogError="dialogError"
      :before-close-fn="handleCloseSession"
      @dialogClosed="closeDialogError($event)">
    </dialog-generic-error>
    <dialog-generic-success
      :dialogSuccess="dialogSuccess"
      @dialogClosed="closeDialogSuccess($event)">
    </dialog-generic-success>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
export default {
  props: ['isVisible', 'rowDelete', 'codcomercio'],
  data () {
    return {
      dialogVisible: false,
      dialogError: false,
      dialogSuccess: false,
      errorMessage: ''
    }
  },
  ...mapGetters([
    'getDeleteTpvData'
  ]),
  methods: {
    handleClose () {
      this.$emit('closingDialog', this.dialogVisible)
    },
    deleteTPV () {
      this.rowDelete.codcom = this.codcomercio
      this.$store.dispatch('deleteTpv', this.rowDelete).then(r => {
        this.refreshListTpv()
        this.handleClose()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          this.displayConfirmSuccess()
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    closeDialogSuccess (e) {
      this.dialogSuccess = e
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    displayConfirmSuccess () {
      this.dialogSuccess = true
    },
    refreshListTpv () {
      this.$store.dispatch('listTpv', { codcom: this.codcomercio }).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } if (r.vacio === true) {
          this.$emit('mostrarTerminal', false)
        } else {
          this.$emit('mostrarTerminal', true)
        }
      }).catch(e => {
        console.error('Error in list TPV - App', e)
      })
    }
  },
  components: {
    DialogGenericError,
    'dialog-generic-success': DialogConfirmSuccess
  }
}
</script>

<style lang="scss" scoped>

.estas-a-punto-de-eli {
  height: 72px;
  width: 360px;
  color: #6E767D;
  align: center;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 24px;
}

</style>
